const state = {
  allowed: [
    'PT',
    'GB',
    'ES',
  ],
  default: 'PT',
}

const getters = {
  allowed: state => state.allowed,
}

export default {
  state,
  getters,
}
